import { Button } from '@carbon/react';

import config from 'core/config';
import { useAuthController } from 'core/user/auth';
import NoAccessModal from 'features/auth/NoAccessModal';
import styles from 'theme/features/auth/login.module.scss';

const Login = ({ hasAccess }) => {
  const { login, logout } = useAuthController();

  const handleRequestAccess = () => {
    window.location.href = config.contactUs.url;
  };

  return (
    <div className={styles.wrapper}>
      <NoAccessModal open={!hasAccess} onRequestAccess={handleRequestAccess} onLogout={logout} />
      <aside className={styles.aside}>
        <h1 className={styles['aside__header']}>Let's Create Space</h1>
      </aside>
      <section className={styles.actions}>
        <Button size="sm" onClick={() => login('/')}>
          Login
        </Button>
        <Button kind="ghost" size="sm">
          <a href={config.contactUs.url}>Request Access</a>
        </Button>
      </section>
    </div>
  );
};

export default Login;
